import React from "react";
import styles from "./spinner.module.css";

export default function Spinner({ size = 7, color }) {
  return (
    <div className="" style={size ? { height: `${size / 2}em` } : undefined}>
      <div
        className={styles.spinner}
        style={{
          fontSize: size ? `${size}px` : undefined,
          color: color || "white",
        }}
      ></div>
    </div>
  );
}
